import SelectLanguage from '@/components/general/SelectLanguage';
import BackgroundPanel from '@/components/layout/BackgroundPanel';
import { Outlet } from 'react-router-dom';

export default function FormPanelLayout() {
    return (
        <div className='container relative min-h-screen flex flex-col items-center justify-center gap-10 lg:grid lg:grid-cols-2'>
            <BackgroundPanel />
            <div className='absolute top-4 right-4 md:right-8 md:top-8'>
                <SelectLanguage />
            </div>
            <div className='w-[512px] max-w-[98%] md:max-w-[90%]'>
                <Outlet />
            </div>
        </div>
    );
}
